import { Box, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { UploadFile } from "generated/openApi";
import produce from "immer";
import { initDataModel } from "utils";

export const ServiceFiles = (props: { files: UploadFile[]; setFiles: (value: UploadFile[]) => void }) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();

  return (
    <Stack spacing="sm">
      <Box>
        <Grid ref={breakpointsRef} container spacing="sm">
          {props.files.map((file, index) => (
            <Grid item xs={smallFieldBreakpoints}>
              <FilePanel
                key={index}
                fileName={file.fileName}
                fileRef={file.fileRef}
                fileSize={file.fileSize}
                uploadingData={file?.uploadingData}
                cancel={() =>
                  props.setFiles(
                    produce(props.files, (draft) => {
                      draft.splice(index, 1);
                    })
                  )
                }
              />
            </Grid>
          ))}

          <Grid item xs={smallFieldBreakpoints}>
            <FilePanel
              onFileChange={(fileName, fileSize, uploadingData) => {
                props.setFiles(
                  produce(props.files, (draft) => {
                    draft.push(
                      initDataModel<UploadFile>({
                        fileName: fileName,
                        fileSize: fileSize,
                        uploadingData: uploadingData,
                      })
                    );
                  })
                );
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Typography variant="caption">Files will be added for each selected Service</Typography>
    </Stack>
  );
};
